import { Alert, Button, HFlow, Icon, Theme, useStyles } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { SistemaExternoIframe, sistemaExternoIframeStyles } from './components/SistemaExternoIframe'
import { useLinkSistemaExterno } from './components/useLinkSistemaExterno'
import { useSistemasExternosMenuLateral } from './useSistemasExternosMenuLateral'

export const SISTEMAS_EXTERNOS_PATH = '/sistemas-externos'

export function SistemaExternoMenuLateralView() {
  const { sistemaExternoId } = useParams<{ sistemaExternoId: string }>()
  const { classes } = useStyles(createStyles)

  const { sistemasExternos, loading: loadingSistemas } = useSistemasExternosMenuLateral()

  const sistemaExternoSelecionado = useMemo(() => {
    if (!sistemaExternoId || !sistemasExternos) return null
    return sistemasExternos.find((s) => s.id === sistemaExternoId) ?? null
  }, [sistemaExternoId, sistemasExternos])

  const { url, refresh, loading } = useLinkSistemaExterno(sistemaExternoSelecionado)

  if (loadingSistemas) {
    return (
      <PageContent type='filled'>
        <div className={classes.loadingMessage}>Carregando...</div>
      </PageContent>
    )
  }

  if (!sistemaExternoSelecionado) {
    return (
      <PageContent type='filled'>
        <div className={classes.notFoundMessage}>Sistema externo não encontrado.</div>
      </PageContent>
    )
  }

  return (
    <PageContent fluid type='filled' containerStyle={classes.page}>
      <Alert type='info' inline style={{ marginBottom: '0.5rem' }}>
        Os sistemas externos não possuem relação com o e-SUS APS. Em caso de problemas, contate o administrador da
        instalação.
      </Alert>
      <div className={classes.iframeCard}>
        <div className={classes.iframeCardHeader}>
          <HFlow hSpacing={0.5} alignItems='center'>
            <span className={classes.iframeCardTitle}>{sistemaExternoSelecionado.nome}</span>
          </HFlow>
          <Button
            size='small'
            skin='ghost'
            style={sistemaExternoIframeStyles.reloadButton}
            onClick={refresh}
            disabled={loading}
          >
            <Icon icon='undo' />
          </Button>
        </div>
        <div className={classes.iframeCardContent}>
          <SistemaExternoIframe nome={sistemaExternoSelecionado.nome} url={url} />
        </div>
      </div>
    </PageContent>
  )
}

const createStyles = (theme: Theme) => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  } as const,
  iframeCard: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    background: theme.pallete.surface.main,
    border: `1px solid ${theme.pallete.divider}`,
    borderRadius: theme.radius.modal,
  } as const,
  iframeCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.5rem 1rem',
    borderBottom: `1px solid ${theme.pallete.divider}`,
    background: theme.pallete.gray.c90,
  } as const,
  iframeCardTitle: {
    fontWeight: 'bold',
    fontSize: '1rem',
  } as const,
  iframeCardContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  } as const,
  loadingMessage: {
    padding: '2rem',
    textAlign: 'center',
  } as const,
  notFoundMessage: {
    padding: '2rem',
    textAlign: 'center',
    color: theme.pallete.text.secondary,
  } as const,
})
